import axios from 'axios';
import { AxiosError } from 'axios';

import { BAD_REQUEST, CommonResult, FORBIDDEN, INTERNAL_SERVER_ERROR, NOT_FOUND, OK } from '../Common';
import { processAxiosError } from '../../utils/AxiosInterceptors/ErrorInterceptor';
export interface ProxyLoginApiRequest {
  crewCd: string;
  agencyCd: string;
  crewCdOrigin: string;
  agencyCdOrigin: string;
  token: string;
}

export interface ProxyLoginApiResponse {
  result?: CommonResult;
}

const endpoint = process.env.REACT_APP_API_URL;
const url = `${endpoint}`;

export async function proxyLoginAgencyApi(request: ProxyLoginApiRequest): Promise<ProxyLoginApiResponse> {
  try {
    const { data, status } = await axios.post<ProxyLoginApiResponse>(`${url}/proxylogin/agency/redirect`, request);
    switch (status) {
      case OK.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(INTERNAL_SERVER_ERROR.message);
      case BAD_REQUEST.status:
        throw new Error(BAD_REQUEST.message);
      case NOT_FOUND.status:
        throw new Error(NOT_FOUND.message);
      case FORBIDDEN.status:
        throw new Error(FORBIDDEN.message);
      default:
        throw new Error('APIとの接続に失敗しました');
    }
  } catch (error) {
    const errorResponse = processAxiosError(error as AxiosError);
    return {
      ...errorResponse.data,
    };
  }
}
